import { Injectable } from '@angular/core';
import { UserProfileConnector } from '@spartacus/user/profile/core';
import { Observable } from 'rxjs';
import {DocumentIdentifierType, JobType, UserTaxGroup } from 'src/app/spartacus/spartacus-custom.module';
import { CustomUserProfileAdapter } from './custom-user-profile.adapter';

@Injectable({
  providedIn: 'root',
})
export class CustomUserProfileConnector extends UserProfileConnector {

  constructor(protected adapter: CustomUserProfileAdapter) {
    super(adapter);
  }

  getJobTypes(): Observable<JobType[]> {
    return this.adapter.loadJobTypes();
  }

  getUserTaxGroups(): Observable<UserTaxGroup[]> {
    return this.adapter.loadUserTaxGroups();
  }
  getDocumentIdentifierTypes(): Observable<DocumentIdentifierType[]> {
    return this.adapter.loadDocumentIdentifierTypes();
  }

  override requestForgotPasswordEmail(userEmailAddress: string): Observable<unknown> {
    return this.adapter.requestForgotPasswordEmail(userEmailAddress);
  }
}
